import type { BankAccount } from '@/shared/api/resources';

/** Permissao propria para trocar a conta bancaria e o Pix da corretora. */
export const permissaoDadosBancarios = 'corretores.dados_bancarios.update';

/**
 * Dica mostrada a quem ve a conta e o Pix sem poder troca-los.
 *
 * O servidor recusa a troca de qualquer forma. A dica existe para que a pessoa
 * saiba por que o campo esta travado e a quem pedir, em vez de achar que a tela
 * quebrou.
 */
export const dicaDadosBancarios =
  'Somente quem tem a permissao de alterar dados bancarios da corretora troca a conta e o Pix, porque sao o destino do repasse. Quem decide quem tem a permissao e a administracao.';

/** Conta bancaria em uma linha, para leitura. Vazia quando nao ha conta. */
export function descreveConta(conta: BankAccount): string {
  if (!conta.bank_code) return '';
  const agencia = conta.agency_digit
    ? `${conta.agency}-${conta.agency_digit}`
    : conta.agency;
  const numero = conta.account_digit
    ? `${conta.account}-${conta.account_digit}`
    : conta.account;
  const tipo = conta.account_type === 'poupanca' ? 'poupanca' : 'corrente';
  return `Banco ${conta.bank_code}, agencia ${agencia}, conta ${tipo} ${numero}`;
}
